export default function AboutBlurb({ title, subtitle, dates, description }) {
    return (
        <article className="reveal flex flex-col md:flex-row md:gap-10 lg:gap-16">
            <header className="md:w-2/5 flex flex-col shrink-0">
                <h2 className="about-blurb-title text-d-green font-baskerville">{title}</h2>
                <h5 className="text-l-green mt-1">{subtitle}</h5>
                <p className="font-stix text-l-brown mt-1">{dates}</p>
            </header>
            <div className="md:w-3/5 mt-4 md:mt-2">
                <p className="text-brown">{description}</p>
            </div>
        </article>
    );
}
